export default "__VITE_ASSET__e91925f4__"